<template>
  <Sidebar :is_empty="true" />
  <Content class="page-content">
    <Loading v-if="is_loading" class="static" />
    <div class="inner page-wrap" v-else>
      <header class="page-header">
        <h1 v-html="page_title"></h1>
      </header>
      <main class="enter" v-html="page_content"></main>
    </div>
  </Content>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';
import Sidebar from '@/components/Sidebar.vue';
import Loading from '@/components/ui/Loading.vue';
import Content from '@/components/ui/Content.vue';

const route = useRoute();
const is_loading = ref(true);
const page_title = ref('');
const page_content = ref(null);
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const projectName = app.appContext.config.globalProperties.$ProjectName;

const removeInvalidAnchorTags = (content) => {
  if (!content) return content;

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = content;

  const anchorTags = tempDiv.querySelectorAll('a');

  anchorTags.forEach((anchor) => {
    const href = anchor.getAttribute('href');
    if (!href || href.trim() === '') {
      anchor.outerHTML = anchor.innerHTML;
    }
  });

  return tempDiv.innerHTML;
};

onMounted(() => {
  if (route.params.slug) {
    is_loading.value = true;
    let key = '';
    switch (route.params.slug) {
      case 'motom-privacy-policy':
        key =
          projectName === 'sephora'
            ? 'sephora_merchant_portal_motom_privacy_policy'
            : projectName === 'cj'
            ? 'cj_merchant_portal_motom_privacy_policy'
            : 'merchant_portal_privacy_policy';
        break;

      case 'motom-terms-of-use':
        key =
          projectName === 'sephora'
            ? 'sephora_merchant_portal_motom_terms_of_use'
            : projectName === 'cj'
            ? 'cj_merchant_portal_motom_terms_of_use'
            : 'merchant_portal_terms_of_use';
        break;

      // case 'sephora-storefront-terms':
      //   if (projectName === 'sephora') {
      //     key = 'sephora_storefront_terms';
      //   } else {
      //     window.location.href = '/';
      //   }
      //   break;

      default:
        // window.location.href = '/';
        break;
    }

    ajax
      .get(`/page/get-page?name=${key}`)
      .then((response) => {
        // Handle successful response
        const data = response.data.data.data;
        page_title.value = data.title;
        // 过滤掉 <p>&nbsp;</p> 标签
        page_content.value = data.content ? data.content.replace(/<p>&nbsp;<\/p>/g, '') : '';
        page_content.value = removeInvalidAnchorTags(page_content.value);
      })
      .catch((error) => {
        // window.location.href = '/';
      })
      .finally(() => {
        is_loading.value = false;
      });
  } else {
    // window.location.href = '/';
  }
});
</script>

<style lang="scss">
.page-wrap {
  padding: 24px 32px;
  overflow: auto;
  max-height: 100%;
}

.page-content {
  height: calc(100vh - 16px);
  overflow: hidden;

  .enter {
    $margin: 16px;
    color: var(--Text-primary);
    padding: 16px 0;
    overflow: hidden;
    max-width: 800px;
    margin: 0 auto;

    .section-header-title,
    .section-header-title + br {
      display: none;
    }

    .open-popup {
      color: var(--Blue-30);
      cursor: pointer;
      text-decoration: underline;
    }

    .section-content > * {
      margin-bottom: $margin;
    }

    .section-header > p {
      margin-bottom: $margin;
    }

    .section-content time:first-child {
      display: block;
      margin-bottom: 8px;
    }

    h1 {
      font: var(--medium-26);
      margin: $margin 0;
    }

    h2 {
      font: var(--medium-24);
      margin: $margin 0;
    }

    h3 {
      font: var(--medium-22);
      margin: $margin 0;
    }

    h4 {
      font: var(--medium-16);
      margin: $margin 0;
    }

    h5 {
      font: var(--medium-12);
      margin: $margin 0;
    }

    h6 {
      font: var(--medium-10);
      margin: $margin 0;
    }

    ul {
      padding-left: 24px;
      margin-bottom: $margin;

      li {
        margin-bottom: calc($margin / 2);
        list-style: disc;
      }
    }

    ol {
      padding-left: 24px;
      margin-bottom: $margin;

      li {
        margin-bottom: calc($margin / 2);
        list-style: decimal;
      }
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: $margin;
      border: 1px solid var(--Border-default);

      th,
      td {
        border: 1px solid var(--Border-default);
        padding: calc($margin / 2);
      }

      th {
        background-color: var(--Neu-10);
      }
    }

    hr {
      border: none;
      border-top: 1px solid var(--Black-40);
      margin: $margin 0;
    }

    strong {
      font-weight: 700;
    }

    em {
      font-style: italic;
    }

    a {
      color: var(--Blue-30);
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }

    p {
      margin-bottom: 16px;
    }

    iframe,
    img {
      max-width: 100%;
      height: auto;
      display: block;
    }
  }
}

.page-header {
  display: flex;
  border-bottom: 1px solid var(--Black-50);
  padding-bottom: 16px;
  max-width: 800px;
  margin: 0 auto;

  h1 {
    font: var(--demi-30);
    color: var(--Text-primary);
    flex: 1;

    @media screen and (max-width: $mobile_size) {
      font: var(--demi-22);
    }
  }
}
</style>
